// ── groupBuyInterest.js — 공동구매 관심 등록 데이터 모델 ────────
// localStorage 기반 (per-user). 향후 Firestore 마이그레이션 예정.
// 카테고리별 관심도 + 알림 수신 설정 저장.

const STORAGE_KEY = 'semfit_groupbuy_interest';

// ── 카테고리 정의 ──
export const GROUPBUY_CATEGORIES = [
  { id: 'food_raw',       label: '농수축산물 (원물)',  icon: '🥬', desc: '쌀·채소·고기·생선' },
  { id: 'food_processed', label: '가공·냉동 식자재',   icon: '📦', desc: '소스·면류·냉동식품' },
  { id: 'beverage',       label: '음료·주류',          icon: '🥤', desc: '음료·소주·맥주' },
  { id: 'disposable',     label: '일회용품·포장재',    icon: '🥡', desc: '용기·포장지·이쑤시개' },
  { id: 'cleaning',       label: '청소·위생용품',      icon: '🧴', desc: '세제·위생장갑·휴지' },
  { id: 'kitchen',        label: '주방용품·소모품',    icon: '🍳', desc: '조리기구·필름' },
  { id: 'office',         label: '사무·결제 용품',     icon: '💳', desc: '영수증지·POS 자재' },
];

// ── Mock 안건 데이터 (실제 협업 전까지 데모용) ──
export const MOCK_DEALS = [
  {
    id: 'deal_001',
    title: '대한제분 강력분 25kg × 10포',
    category: 'food_processed',
    leadStore: '제일베이커리 (서울 강남)',
    originalPrice: 38000,
    groupPrice: 33000,
    discountPct: 13,
    target: 15,
    joined: 8,
    deadline: '2026-05-20',
    status: 'recruiting',  // recruiting | closing_soon | closed
  },
  {
    id: 'deal_002',
    title: '농심 라면 박스 단위 (30개입)',
    category: 'food_processed',
    leadStore: '한식당협회 공동',
    originalPrice: 22000,
    groupPrice: 18000,
    discountPct: 18,
    target: 20,
    joined: 16,
    deadline: '2026-05-15',
    status: 'closing_soon',
  },
  {
    id: 'deal_003',
    title: '종이컵 6.5oz · 1000매 × 5박스',
    category: 'disposable',
    leadStore: '서울 카페업주 모임',
    originalPrice: 35000,
    groupPrice: 26000,
    discountPct: 26,
    target: 12,
    joined: 4,
    deadline: '2026-05-22',
    status: 'recruiting',
  },
];

// ── localStorage I/O ──
export function loadInterest() {
  if (typeof window === 'undefined') return defaultInterest();
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultInterest();
    const parsed = JSON.parse(raw);
    return { ...defaultInterest(), ...parsed };
  } catch (e) {
    return defaultInterest();
  }
}

export function saveInterest(interest) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(interest));
  } catch (e) { /* swallow */ }
}

function defaultInterest() {
  const cats = {};
  GROUPBUY_CATEGORIES.forEach(c => { cats[c.id] = false; });
  return {
    registered: false,    // 관심 등록 했는지
    categories: cats,     // { id: bool }
    avgMonthlyFoodCost: 0,
    notifyEmail: true,
    registeredAt: null,
  };
}

// ── 헬퍼 ──
export function isRegistered() {
  return loadInterest().registered === true;
}

export function selectedCategoriesCount(interest) {
  return Object.values(interest.categories || {}).filter(Boolean).length;
}
